import React from 'react';

import styles from './ShimmerLoading.module.scss';

type ShimmerLoadingProps = {
    headerLength: number;
    headerWidths: string[];
    rowWidth?: string;
};

const ShimmerLoading: React.FC<ShimmerLoadingProps> = ({ headerLength, headerWidths, rowWidth }) => {
    const calculateWidthInPixel = (columnWidth: string) => {
        const screenWidth = window.innerWidth;
        if (columnWidth.endsWith('%')) {
            const percentage = parseFloat(columnWidth);
            return isNaN(percentage) ? 0 : (percentage / 100) * screenWidth;
        }
        const pixels = parseFloat(columnWidth);
        return isNaN(pixels) ? 0 : pixels;
    };

    const gridTemplateColumns = headerWidths
        .slice(0, headerLength)
        .map((width) => {
            const widthInPixel = calculateWidthInPixel(width);
            return `${widthInPixel}fr`;
        })
        .join(' ');

    return (
        <div className={styles.shimmer} style={{ width: rowWidth || '100%' }}>
            {Array.from({ length: 13 }).map((_, rowIndex) => (
                <div key={rowIndex} className={styles.row} style={{ gridTemplateColumns }}>
                    {Array.from({ length: headerLength }).map((_, colIndex) => (
                        <div key={colIndex} className={styles.cell}>
                            <div className={styles.shimmerCell}></div>
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
};

export default ShimmerLoading;
